import { render, staticRenderFns } from "./regions.vue?vue&type=template&id=531c4376&scoped=true"
import script from "./regions.vue?vue&type=script&lang=js"
export * from "./regions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c4376",
  null
  
)

export default component.exports